import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import parse from 'html-react-parser';
import Sidebar from './sidebar';
import ScrollAnimation from 'react-animate-on-scroll';

class IESCourses extends Component {

    render() {

        let publicUrl = process.env.PUBLIC_URL+'/'

    return  <div className="course-single-area pd-top-120 pd-bottom-110">
		  <div className="container">
		    <div className="row">
		      <div className="col-lg-8 ">
		        <div className="event-detaila-inner">
		          {/* <div className="thumb mb-4">
		            <img src={publicUrl+"assets/img/other/5.png"} alt="img" />
		          </div> */}
				  <ScrollAnimation animateIn="fadeInRight">
				  
				  <p><b>IES Exam also known as Indian Engineering Services or Engineering Services Examination (ESE)</b> is considered the most competitive and respected job for the aspirants selected as engineers under the various ministries and departments of Govt. of India. The appointed IES engineers are given service in Group A departments to manage a large segment of the public sector economy, which consists of Indian Railways, Power, Telecommunications, Central Water engineering, Defense service of Engineers & Central Engineering Service.
                    </p>
                    <p>It is one of the best career paths to choose, which shows good progression as you gradually grow.</p>
                    <p><b>The first position offered is Assistant Executive Engineer and the hierarchy ends at the position of Chairman/ Managing Director.</b></p>
                    <p><b>MIET offers extensive coaching for the IES exam to students who dream about getting into government jobs. We help you understand the subject and use tricks to crack the exam with ease. With the thorough practice of all aptitude-related questions from MIET, you can complete the test with no delays and compete with top aspirants in the nation.</b></p>
                    </ScrollAnimation>	

					<ScrollAnimation animateIn="fadeInRight"><br/>
						<h5 className="mb-0 mt-2">Highlights:</h5><br/>
						<p>The Union Public Service Commission (UPSC) is responsible for conducting the Engineering Services Examination (ESE). The Commission will shortlist the candidates for the posts through
						</p>
						<ul>
                            <li><b>Preliminary Examination</b></li>
                            <li><b>Main Examination</b></li>
                            <li><b>Interview</b></li>
                        </ul>
                    </ScrollAnimation>	
                    <ScrollAnimation animateIn="fadeInRight">
                        <div className='blog-details-page-content'>
                            <blockquote>
                            <p><b>Mode of Classes </b>: Online, Offline & Hybrid</p>
                            <p><b>Classes </b>: Evening & Weekend Batches</p>
                            </blockquote>
                        </div>
					</ScrollAnimation>

                    <ScrollAnimation animateIn="fadeInRight">
					
						<table>
							<tr>
								<th>Exam</th>
								<th>Engineering Services Examination (ESE)</th>
							</tr>
							<tr>
								<td>Conducted by</td>
								<td>Union Public Service Commission (UPSC)</td>
							</tr>
                            <tr>
								<td>Exam level</td>
								<td>National</td>
							</tr>
                            <tr>
								<td>Frequency</td>
								<td>Once in a year</td>
							</tr>
                            <tr>
								<td>Educational qualifications</td>
								<td>Engineering</td>
							</tr>
                            <tr>
								<td>Age limit</td>
								<td>21-30 years</td>
							</tr>
                            <tr>
								<td>Number of vacancies</td>
								<td>339</td>
							</tr>
                            <tr>
								<td>Selection process</td>
								<td>Preliminary, Main Exam & Interview</td>
							</tr>
                            <tr>
								<td>Preliminary exam</td>
								<td>Objective-type</td>
							</tr>
                            <tr>
								<td>Main exam</td>
								<td>Conventional</td>
							</tr>
                            <tr>
								<td>Admit card availability</td>
								<td>3 weeks before the exam</td>
							</tr>
                            <tr>
								<td>Withdrawal of application</td>
								<td>Yes</td>
							</tr>
                            <tr>
								<td>Official website</td>
								<td>www.upsc.gov.in</td>
							</tr>
                            <tr>
								<td>Application fee</td>
								<td>Rs 200</td>
							</tr>
						</table><br/>
                    </ScrollAnimation>
               
                  <ScrollAnimation animateIn="fadeInRight">
					
                    <h5 className="mb-0 mt-2">Eligibility</h5><br/>
                    
                    <ul>
                        <li><b>Medical Examination:</b> Every candidate has to undergo a medical examination decided by the Ministry of communications, Department of Telecommunications irrespective of the fact that he/she has appeared for such medical examination in the past and found fit/unfit on the basis of earlier examination.</li>
                        <li><b>Physical Standards:</b> Candidates must be physically fit according to physical standards for admission to Engineering Services Examination.</li>
                        <li><b>Nationality:</b><br/>
                            <b>A candidate must be either: </b>
                            <ul>
                                <li>a Citizen of India or </li>
                                <li>a subject of Nepal or </li>
                                <li>a subject of Bhutan or </li>
                                <li>a Tibetan refugee who came over to India before January 1, 1962, with the intention of permanently settling in India, or (e) a person of Indian origin who has migrated from Pakistan, Burma, Sri Lanka or East African Countries of Kenya, Uganda, the United Republic of Tanzania, Zambia, Malawi, Zaire, and Ethiopia or from Vietnam with the intention of permanently settling in India.</li>
                            </ul>
                            <b>Note</b>
                            <ul>
                                <li>Provided that a candidate belonging to categories (b), (c), (d) and (e) above shall be a person in whose favour a certificate of eligibility has been issued by the Government of India.</li>
                                <li>A candidate in whose case a certificate of eligibility is necessary may be admitted to the examination but the offer of appointment may be given only after the necessary eligibility certificate has been issued to him/her by the Government of India.</li>
                            </ul>
                        </li>
                        <li><b>Age:</b>
                            <ul>
                                <li>A candidate for this examination must have attained the age of 21 years and must not have attained the age of 30 years on the 1st January 2023. i.e., he/she must have been born not earlier than 2nd January 1993 and not later than 1st January 2002. </li>
                                <li>The upper age limit of 30 years will be relaxable up to 35 years in the case of Government servants of the following categories if they are employed in a Department/Office under the control of any of the authorities mentioned in column 1 below and apply for admission to the examination for all or any of the Service(s)/Posts mentioned in column 2, for which they are otherwise eligible.</li>
                                <li>A candidate who has been continuously in a temporary service on a regular basis in the particular mentioned below Department/Office for at least 3 years on 1st January 2023.</li>
                            </ul>
                        </li>
                    </ul>
                    </ScrollAnimation>	
					
                    <ScrollAnimation animateIn="fadeInRight">
                        <div className='blog-details-page-content'>
                            <blockquote>
                            <h5 className="mb-0 mt-2">Syllabus:</h5>
                    <p>The recruitment of qualified candidates is made under the following categories: </p>
                    <ul>
                        <li><b>Civil Engineering</b></li>
                        <li><b>Mechanical Engineering</b></li>
                        <li><b>Electrical Engineering</b></li>
                        <li><b>Electronics & Telecommunication Engineering</b></li>
                    </ul>
                    <table>
							<tr>
								<th>Category</th>
								<th>Group-A Services/Posts</th>
							</tr>
							<tr>
								<td><b>Category I <br/>Civil Engineering</b>
                                </td>
								<td>
                                    <ul>
                                        <li>Central Engineering Service</li>
                                        <li>Central Engineering Service (Roads),  Group-A (Civil Engineering Posts)</li>
                                        <li>Survey of India Group ‘A’ Service </li>
                                        <li>AEE (Civil) in Border Road Engineering Service </li>
                                        <li>Indian Defense Service of Engineers </li>
                                        <li>AEE (QS&C) in MES Surveyor Cadre </li>
                                        <li>Central Water Engineering (Group 'A') Service.</li>
                                    </ul>
                                </td>
							</tr>
                            <tr>
								<td><b>Category  II <br/>Mechanical Engineering</b>
                                </td>
								<td>
                                    <ul>
                                        <li>AEE in GSI Engineering Service Gr ‘A’</li>
                                        <li>Indian Defense Service of Engineers.</li>
                                        <li>Indian Naval Armament Service (Mechanical Engineering Posts) </li>
                                        <li>Indian Naval Material Management Service (Mechanical Engineering Posts).  </li>
                                        <li>Central Water Engineering (Group 'A') Service. </li>
                                        <li>Defense Aeronautical Quality Assurance Services / SSO-II (Mechanical).  </li>
                                        <li>Central Electrical and Mechanical Engineering Service (Mechanical Engineering). </li>
                                        <li>Central Power Engineering Service Gr 'A' (Mechanical Engineering Posts).  </li>
                                        <li>*AEE (Electrical and Mechanical) in Border Roads Engineering Service (Mechanical Engineering Posts) </li>
                                        <li>Assistant Development Officer (Engineering). </li>
                                        <li>Central Power Engineering Service Gr 'B' (Mechanical Engineering Posts). </li>
                                    </ul>
                                </td>
							</tr>
                            <tr>
								<td><b>Category  III  <br/>Electrical Engineering</b>
                                </td>
								<td>
                                    <ul>
                                        <li>Central Electrical & Mechanical Engineering Service (Electrical Engineering Posts)</li>
                                        <li>Indian Defense Service of Engineers </li>
                                        <li>Indian Naval Material Management Service (Electrical Engineering Posts).</li>
                                        <li>Central Power Engineering Service Gr 'A' (Electrical Engineering Posts). </li>
                                        <li>Indian Naval Armament Service (Electrical Engineering Posts). </li>
                                        <li>Defense Aeronautical Quality Assurance Service/SSO-II (Electrical). </li>
                                        <li>Assistant Development Officer (Engineering). </li>
                                        <li>Central Power Engineering Service Gr 'B' (Electrical Engineering Posts). </li>
                                    </ul>
                                </td>
							</tr>
							<tr>
								<td><b>Category IV  <br/>Electronics & Telecommunication Engineering</b>
                                </td>
								<td>
                                    <ul>
                                        <li>Indian Telecommunication Service Gr 'A' </li>
                                        <li>Indian Naval Armament Service (Electronics and Telecom Engineering Posts). </li>
                                        <li>Indian Naval Material Management Service (Electronics and Telecom Engineering Posts)  </li>
                                        <li>Defense Aeronautical Quality Assurance Service / SSO-II (Electronics & Tele.).  </li>
                                        <li>Central Power Engineering Service Gr 'A' (Electronics & Telecom Engineering Posts). </li>
                                        <li>Assistant Development Officer (Engineering). </li>
                                        <li>Junior Telecom Officer Gr ‘B’.</li>
                                        <li>Central Power Engineering Service Gr 'B' (Electronics & Telecom Engineering posts).</li>
                                    </ul>
                                </td>
							</tr>
							
						</table><br/>
                            </blockquote>
                        </div>
					</ScrollAnimation>
                    <h5 className="mb-0 mt-2">Exam Pattern:</h5><br/>
                    <p><b>1. Preliminary Exam:</b></p>
                    <table>
							<tr>
								<th>Paper</th>
								<th>Subject</th>
								<th>Question-type</th>
								<th>Marks</th>
								<th>Duration</th>
							</tr>
							<tr>
								<td>Paper I</td>
								<td>General Studies And Engineering Aptitude</td>
								<td>Objective</td>
								<td>200</td>
								<td>2 hours</td>
								{/* <td rowspan="4">120 Minutes </td> */}
							</tr>
							<tr>
								<td>Paper II</td>
								<td>Engineering (Civil/Mechanical/Electrical/Electronics and Telecommunication)</td>
								<td>Objective</td>
								<td>300</td>
								<td>3 hours</td>
								{/* <td rowspan="4">120 Minutes </td> */}
							</tr>
                            <tr>
								<td>Total</td>
								<td></td>
								<td></td>
								<td>500 </td>
								<td>5 hours</td>
								{/* <td rowspan="4">120 Minutes </td> */}
							</tr>
						</table><br/>
                    <p><b>2. Main Exam:</b></p>
                    <table>
							<tr>
								<th>Paper</th>
								<th>Subject</th>
								<th>Question-type</th>
								<th>Marks</th>
								<th>Duration</th>
							</tr>
							<tr>
								<td>Paper I</td>
								<td>Engineering (Civil/Mechanical/Electrical/Electronics and Telecommunication)</td>
								<td>Descriptive</td>
								<td>300</td>
								<td>3 hours</td>
								{/* <td rowspan="4">120 Minutes </td> */}
							</tr>
							<tr>
								<td>Paper II</td>
								<td>Engineering (Civil/Mechanical/Electrical/Electronics and Telecommunication)</td>
								<td>Descriptive</td>
								<td>300</td>
								<td>3 hours</td>
								{/* <td rowspan="4">120 Minutes </td> */}
							</tr>
                            <tr>
								<td>Total</td>
								<td></td>
								<td></td>
								<td>600 </td>
								<td>6 hours</td>
								{/* <td rowspan="4">120 Minutes </td> */}
							</tr>
						</table><br/>
                  </div>
		      </div>
			  <Sidebar courseRestriction="IES"/>
		    </div>
		  </div>
		</div>

        }
}

export default IESCourses